import { createApiSlice } from "@common";
import {
  CURD_CONTACT_METHOD
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addContactMethod",
    method: "post",
    url: CURD_CONTACT_METHOD,
    stateKey: "message",
  },
  {
    name: "getContactMethod",
    method: "get",
    url: CURD_CONTACT_METHOD,
    stateKey: "data",
  },
  {
    name: "updateContactMethod",
    method: "put",
    url: CURD_CONTACT_METHOD,
    stateKey: "message",
  },
  {
    name: "deleteContactMethod",
    method: "delete",
    url: CURD_CONTACT_METHOD,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "contactMethod",
  apiConfig,
  customReducers,
);
const contactMethodSlice = slice;
// Export the slice's reducer
export default contactMethodSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addContactMethod,
  getContactMethod,
  updateContactMethod,
  deleteContactMethod
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
